import { z } from "zod";

import { closingStatusSchema } from "./closing-carton";

export const closedCartonSchema = z.object({
	closingId: z.string(),
	packagingSolutionId: z.string(),
	alias: z.string(),
	closingMachineId: z.string(),
	closedDateUTC: z.coerce.date(),
	status: closingStatusSchema,
	identifier: z.string().nullish(), // can remove nullish when production service is enforcing non-null
	failureReason: z.string().nullish(),
});

export const closedCartonsResponseSchema = z.object({
	items: z.array(closedCartonSchema),
	totalCount: z.number(),
	pageNumber: z.number(),
	pageSize: z.number(),
});

export type ClosedCarton = z.infer<typeof closedCartonSchema>;
export type ClosedCartonsResponse = z.infer<typeof closedCartonsResponseSchema>;
